import Vue from 'vue'
import Vuex from 'vuex'
import {currencyStore} from "@/store/CurrencyStore";
import {addressStore} from "@/store/AddressStore"
import {importConfigStore} from "@/store/ImportConfigStore"
import {exportConfigStore} from "@/store/ExportConfigStore"
import {componentImportStore} from "@/store/ComponentImportStore"
import {componentEditStore} from "@/store/ComponentEditStore"
import {ppanelImportStore} from "@/store/PPanelImportStore"
import {ppanelStore} from "@/store/PPanelStore"
import {fullPpanelExportStore} from "@/store/FullPpanelExportStore"

Vue.use(Vuex);


export default new Vuex.Store({
    modules: {
        currencyStore,
        addressStore,
        importConfigStore,
        componentImportStore,
        ppanelImportStore,
        exportConfigStore,
        ppanelStore,
        fullPpanelExportStore,
        componentEditStore
    }
})
